import { adminUsers } from '@src/helpers/Permission';
import { Permission } from '@src/interfaces/type';
import { useAppSelector } from '@src/store/hooks';
import React from 'react';

const usePermission = () => {
	const { permissions: myPermissions }: any = useAppSelector((state) => state?.currentUser);
	const currentUser: any = useAppSelector((state) => state?.currentUser?.value);
	return (permission: { KEY: string; NAME: string }, entity?: string, meta?: string) => {
		if (currentUser?.userType && adminUsers.includes(currentUser?.userType)) {
			return true;
		}
		// console.log(permission);
		// console.log(entity);
		const isAllowed = myPermissions?.find(
			(per: Permission) =>
				per?.key === permission?.KEY &&
				(per?.entity ? per?.entity === '*' || per?.entity === entity : true)
		);
		// console.log(isAllowed);
		return !!isAllowed;
	};
};

export default usePermission;
